import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const MilestoneTracker = () => {
  const pid = useSelector((state) => state.user.projectId);
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMilestoneData = async () => {
      if (!pid) return;

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `https://api-project360-insights.haqdarshak.com/milestone/project-overview/?pid=${encodeURIComponent(pid)}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setProjectData(data);
      } catch (err) {
        setError(err.message);
        setProjectData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchMilestoneData();
  }, [pid]);

  if (!pid) {
    return <div className="p-4 text-gray-500">No project selected</div>;
  }

  if (loading) {
    return <div className="p-4 text-gray-600">Loading...</div>;
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  if (!projectData) {
    return <div className="p-4 text-gray-500">No milestone data available</div>;
  }

  return (
    <div className="p-6 mx-[2vw] bg-white shadow-lg rounded-2xl border border-gray-200 mt-6">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">
        Project Duration
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-sm">
        {/* Planned Start */}
        <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 hover:bg-gray-100 transition-all">
          <div className="font-medium text-gray-500 mb-1">Planned Start</div>
          <div className="text-gray-900 font-semibold">
            {projectData.project_start_date || "-"}
          </div>
        </div>

        {/* Actual Start */}
        <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 hover:bg-gray-100 transition-all">
          <div className="font-medium text-gray-500 mb-1">Actual Start</div>
          <div className="text-gray-900 font-semibold">
            {projectData.actual_start_date || "-"}
          </div>
        </div>

        {/* Planned End */}
        <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 hover:bg-gray-100 transition-all">
          <div className="font-medium text-gray-500 mb-1">Planned End</div>
          <div className="text-gray-900 font-semibold">
            {projectData.project_end_date || "-"}
          </div>
        </div>

        {/* Actual End */}
        <div className="bg-gray-50 p-4 rounded-xl border border-gray-100 hover:bg-gray-100 transition-all">
          <div className="font-medium text-gray-500 mb-1">Actual End</div>
          <div className="text-gray-900 font-semibold">
            {projectData.actual_end_date || "-"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MilestoneTracker;
